/** Lokale Datenbank der Stationen (IndexedDB): nur eine Warteschlange für Rückgabe-Scans ohne Netz, sonst nichts. */
const DB_VERSION = 1;

export function openStationDb(name: string): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(name, DB_VERSION);
    request.onupgradeneeded = () => {
      request.result.createObjectStore('outbox', { keyPath: 'id' });
      request.result.createObjectStore('meta');
    };
    request.onsuccess = () => {
      resolve(request.result);
    };
    request.onerror = () => {
      reject(request.error ?? new Error('IndexedDB nicht verfügbar'));
    };
  });
}

export function req<T>(request: IDBRequest<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => {
      resolve(request.result);
    };
    request.onerror = () => {
      reject(request.error ?? new Error('IndexedDB-Fehler'));
    };
  });
}

type StoreName = 'outbox' | 'meta';
type Stores = Record<StoreName, IDBObjectStore>;

export async function transact<T>(
  db: IDBDatabase,
  names: readonly StoreName[],
  mode: IDBTransactionMode,
  work: (stores: Stores) => Promise<T>,
): Promise<T> {
  const transaction = db.transaction([...names], mode);
  const done = new Promise<void>((resolve, reject) => {
    transaction.oncomplete = () => {
      resolve();
    };
    transaction.onerror = () => {
      reject(transaction.error ?? new Error('IndexedDB-Fehler'));
    };
    transaction.onabort = () => {
      reject(transaction.error ?? new Error('IndexedDB-Transaktion abgebrochen'));
    };
  });
  const stores = Object.fromEntries(
    names.map((name) => [name, transaction.objectStore(name)]),
  ) as Stores;
  let result: T;
  try {
    result = await work(stores);
  } catch (error) {
    try {
      transaction.abort();
    } catch {
      // schon beendet
    }
    await done.catch(() => undefined);
    throw error;
  }
  await done;
  return result;
}
